import { getCustomerThemeTokens } from '@pelicargo/tenants';
import { modelUtils } from '@pelicargo/utils';

/**
 * `cssVar`, but the tenant's own static token wins over the built-in default.
 *
 * Resolved once at module load, like the rest of the theme. The layering itself lives in
 * `@pelicargo/utils` so it can be tested without reaching across workspaces; this file is just the
 * wiring, because resolving a tenant needs `window.location` and so cannot live in a shared
 * package. See `createThemeVar` for what the three layers are.
 */
export const themeVar = modelUtils.customerTheme.createThemeVar(getCustomerThemeTokens());
